import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { AccountStoreService, HouseholdStoreService } from './store'

@NgModule({
  imports: [CommonModule],
  providers: [
    AccountStoreService,
    HouseholdStoreService
  ],
})
export class SeHouseholdSetupDataAccessStoreModule {}
